import { placeReduxConstants } from '@/constants';

export function place(state = {}, action) {
  switch (action.type) {
    case placeReduxConstants.SET_HOVER:
      return {
        ...state,
        placeHover: action.placeId,
      };
    case placeReduxConstants.REMOVE_HOVER:
      return {
        ...state,
        placeHover: -1,
      };
    case placeReduxConstants.SET_PLACE_DATA:
      return {
        ...state,
        [action.place.id]: { ...action.place },
      };
    default:
      return state;
  }
}
